export const LOCATION_SELECT_PLACEHOLDER = 'Select a location';
export const ALL_LOCATIONS_VALUE = 'ALL';
export const EMPTY_LOCATION_OPTION_LABEL = 'All locations';
